const registrationTypesEnum = [
  { value: 'PATIENT_COUPLE', label: 'Patient - Couple' },
  { value: 'PATIENT_SINGLE', label: 'Patient - Single' },
  { value: 'SPERM_DONOR', label: 'Sperm Donor' },
  { value: 'OOCYTE_DONOR', label: 'Oocyte Donor' },
  { value: 'SURROGATE', label: 'Surrogate' },
];

export default registrationTypesEnum;